"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAdaptableNumberEditor = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const icons_1 = require("../../../components/icons");
const useProperty_1 = tslib_1.__importDefault(require("../../../components/utils/useProperty"));
const fillStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
};
const hostStyle = Object.assign(Object.assign({}, fillStyle), { boxSizing: 'border-box', display: 'flex', flexDirection: 'row', alignItems: 'center' });
const inputStyle = {
    position: 'relative',
    background: 'transparent',
    boxSizing: 'border-box',
    minWidth: 0,
    outline: 'none',
    width: '100%',
    border: 'none',
};
exports.InternalAdaptableNumberEditor = React.forwardRef(function InternalAdaptableNumberEditorFn(props, ref) {
    var _a;
    const inputRef = React.useRef(null);
    const focus = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const [value, setValue] = (0, useProperty_1.default)(props, 'value', props.defaultValue, {
        onChange: (value) => {
            var _a;
            if (value !== '' && value == Number(value)) {
                value = Number(value);
            }
            (_a = props.onValueChange) === null || _a === void 0 ? void 0 : _a.call(props, value);
        },
    });
    React.useImperativeHandle(ref, () => {
        return {
            focus,
            setValue,
        };
    });
    const showClear = props.showClearButton && props.emptyValue != null && value != props.emptyValue;
    return (React.createElement("div", { style: hostStyle, onKeyDown: (e) => {
            if (e.key === 'Tab' && showClear && document.activeElement === inputRef.current) {
                e.stopPropagation();
            }
        } },
        React.createElement("input", { type: (_a = props.type) !== null && _a !== void 0 ? _a : 'number', value: value, onChange: React.useCallback((event) => {
                setValue(event.target.value);
            }, []), style: inputStyle, ref: inputRef }),
        showClear ? (React.createElement("div", { style: {
                display: 'inline-block',
                marginRight: 'var(--ab-space-1)',
                marginLeft: 'var(--ab-space-1)',
            }, onClick: (e) => {
                if (props.emptyValue != null) {
                    setValue(props.emptyValue);
                    e.stopPropagation();
                    focus();
                }
            }, onKeyDown: (e) => {
                if (props.emptyValue != null && e.key === 'Enter') {
                    setValue(props.emptyValue);
                    e.stopPropagation();
                    focus();
                }
            } },
            React.createElement(icons_1.Icon, { size: 18, name: "close", tabIndex: 0 }))) : null));
});
